import { Box } from "@mui/material";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

const { glow } = PRICING_DESIGN_VALUES;

const circleSx = {
  position: "absolute",
  top: 0,
  width: glow.size,
  height: glow.size,
  borderRadius: "50%",
  filter: `blur(${glow.blur})`,
} as const;

export const PricingGlow = () => (
  <Box
    aria-hidden="true"
    sx={{
      position: "absolute",
      inset: 0,
      overflow: "hidden",
      borderRadius: "inherit",
      pointerEvents: "none",
      zIndex: 0,
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: glow.top,
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(1144px, calc(100% - 48px))",
        height: glow.height,
      }}
    >
      <Box
        sx={{
          ...circleSx,
          left: glow.leftOffset,
          backgroundColor: glow.leftColor,
        }}
      />
      <Box
        sx={{
          ...circleSx,
          left: glow.rightOffset,
          backgroundColor: glow.rightColor,
        }}
      />
    </Box>
  </Box>
);
